import { ReactNode } from 'react';
import { classNames } from '@/shared/lib/classNames/classNames';
import cls from './LayoutBase.module.scss';

export enum LayoutBaseTheme {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
}

interface LayoutBaseProps {
    className?: string;
    footerSlot?: ReactNode;
    headerSlot?: ReactNode;
    pageSlot: ReactNode;
    // navBarSlot?: ReactNode;
    sideMenuSlot?: ReactNode;
    theme?: string;
}

export const LayoutBase = (props: LayoutBaseProps) => {
    const { className, theme = '', headerSlot, pageSlot, footerSlot, sideMenuSlot } = props;

    return (
        <div className={classNames(cls.Layout, {}, [className, cls[theme]])}>
            {headerSlot && headerSlot}
            <main className={cls.content}>{pageSlot}</main>
            {sideMenuSlot && sideMenuSlot}
            {footerSlot && footerSlot}
        </div>
    );
};
